import { Trans } from '@lingui/react/macro';

import { usePageFilterContext } from '@/components/page';
import { Panel } from '@/components/panels';
import { BenchmarksWidget } from '@/features/WidgetLibrary';

const BenchmarksByChannel = () => {
  const { pageFilters } = usePageFilterContext();

  return (
    <Panel className="min-h-125" title={<Trans>Total Visits</Trans>} noPadding>
      <BenchmarksWidget pageFilters={pageFilters} />
    </Panel>
  );
};

export default BenchmarksByChannel;
